module.exports = __webpack_public_path__ + "media/images/pc/stores/nagoya/nagoya_concept_03-40845d31502d81ceae62faa09b05a3a4.jpg";